import React from "react";
import { Stack, Typography, Avatar, Box, IconButton } from "@mui/material";
import { Images } from "./../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { HMS, fullName, truncate } from "./../../constants/function";
import OutsideClickHandler from "react-outside-click-handler";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

export default function ArtistProfileRow({
  lastIndex,
  value,
  data,
  play,
  actions,
  toggleMenu,
  isPlaylistNft,
  music,
  studio,
  reference,
}) {
  const [isMenu, setMenu] = React.useState(false);
  const { t } = useTranslation("common");
  const history = useHistory();
  // console.log("value::", value);
  return (
    <tr style={{ position: "relative" }} ref={reference || null}>
      {/* Songs */}
      <td>
        <Stack direction="row" spacing={2}>
          <Stack className={"__music_thumb" + (!studio ? " _cp" : "")}>
            <Avatar
              src={
                data?.thumbnailImg?.filePath ??
                data?.GIF?.filePath ??
                Images.dummy
              }
            />
            {!studio ? (
              <img
                onClick={play}
                className="__play_hover"
                src={Images.play}
                style={{
                  top: value !== 3 ? "-20px" : "0px",
                }}
                alt="play"
              />
            ) : (
              <div
                onClick={() => history.push(`/app/Music/${data._id}`)}
                className="__play_hover"
                src={Images.playlist_icon} // replace with a suitable icon for playlists
                style={{
                  top: value !== 3 ? "-20px" : "0px",
                }}
                alt="playlist"
              />
            )}
          </Stack>
          <Stack direction="column" alignItems="start">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="body1"
                className="fs-16"
                sx={{ textAlign: "left" }}
                title={data["title"]}
              >
                {truncate(data["title"], 27)}
              </Typography>
              {data["private"] ? (
                <LockIcon
                  sx={{
                    width: "11px",
                    height: "11px",
                    padding: "2px",
                    color: "#989898",
                    backgroundColor: "#4E4E4E",
                  }}
                  className="__small_icon _lock_hover"
                />
              ) : null}
            </Stack>
            {value !== 3 ? (
              <Stack
                direction="row"
                sx={{
                  overflowX: "scroll",
                  gap: "6px",
                  width: "245px",
                }}
              // className="scroll_display_musicCard"
              >
                {data.artistData ? (
                  data.artistData.length > 1 ? (
                    data.artistData.map((a, index) => (
                      <Typography
                        onClick={() => {
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        key={index}
                        variant="body2"
                        className="fs-14 fade-text _cp"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {value === 3
                          ? data?.artistDetails?.firstName ?? ""
                          : a?.displayArtistName ?? fullName(a)}
                        {index == data.artistData.length - 1 ? "" : ","}
                      </Typography>
                    ))
                  ) : (
                    data.artistData.map((a, index) => (
                      <Typography
                        onClick={() => {
                          history.push(`/app/ArtistProfile/${a.uId}`);
                        }}
                        key={index}
                        variant="body2"
                        className="fs-14 fade-text _cp"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {value === 3
                          ? data?.artistDetails?.firstName ?? ""
                          : a?.displayArtistName ?? fullName(a)}
                      </Typography>
                    ))
                  )
                ) : (
                  <Typography variant="body2" className="fs-14 fade-text">
                    {value === 3
                      ? data?.artistDetails?.firstName ?? ""
                      : value === 1
                        ? fullName(data["createdByDetails"])
                        : data?.artist ?? ""}
                  </Typography>
                )}
              </Stack>
            ) : null}
          </Stack>
        </Stack>
      </td>

      {/* Top tipper */}
      {value == 4 ? null : (
        <td>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="start"
          >
            {data?.topTipper?.topTipperProfile?.filePath ? (
              <Avatar src={data?.topTipper?.topTipperProfile?.filePath} />
            ) : null}
            <Typography
              variant="body2"
              className="fs-14"
              sx={{ textAlign: "start" }}
            >
              {data?.topTipper?.topTipperName ?? ""}
            </Typography>
          </Stack>
        </td>
      )}

      {value == 2 || value === 3 ? (
        <td>
          <Typography variant="body2" className="fs-14 _cp">
            {data?.platform === "Hedera" ? (
              <img
                src={Images.hedera}
                title={t("dropMenu.m8")}
                onClick={() =>
                  history.push(
                    `/app/${isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                    }/${data.nftId ? data.nftId : data["nftId"]}`
                  )
                }
                alt="nft"
              />
            ) : data?.platform === "Polygon" ? (
              <img
                src={Images.polygoon2}
                title={t("dropMenu.m8")}
                onClick={() =>
                  history.push(
                    `/app/${isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                    }/${data.nftId ? data.nftId : data["nftId"]}`
                  )
                }
                alt="nft"
              />
            ) : data?.platform === "Siki" ? (
              <img
                src={Images.doller}
                title={t("dropMenu.m8")}
                onClick={() =>
                  history.push(
                    `/app/${isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                    }/${data.nftId ? data.nftId : data["nftId"]}`
                  )
                }
                alt="nft"
              />
            ) : (
              <img
                src={Images.near_nft}
                title={t("dropMenu.m8")}
                onClick={() =>
                  history.push(
                    `/app/${isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                    }/${data.nftId ? data.nftId : data["nftId"]}`
                  )
                }
                alt="nft"
              />
            )}
          </Typography>
        </td>
      ) : null}

      {/* Streams */}
      <td>
        <Typography variant="body2" className="fs-14 fade-text">
          {data?.listens ?? 0}
        </Typography>
      </td>

      {/* Top Studio */}
      {value == 4 || value === 2 ? null : (
        <td>
          <Typography variant="body2" className="fs-14 fade-text">
            {data?.topStudio?.playlistName ?? ""}
          </Typography>
        </td>
      )}
      {/* Time */}
      <td className="text-center text-white fs-14">
        {data["duration"]
          ? HMS(data["duration"])
          : data["totalDuration"]
            ? HMS(data["totalDuration"])
            : ""}
      </td>
      <td className="text-right pr18">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setMenu(!isMenu);
          }}
        >
          <MoreVertIcon className="_cp" onClick={() => { }} color="default" />
        </IconButton>
      </td>

      {isMenu ? (
        <OutsideClickHandler onOutsideClick={() => setMenu(false)}>
          <Box
            className="__music_card_menu"
            sx={{ position: "absolute" }}
            style={{ top: lastIndex ? "-40px" : "40px" }}
          >
            {actions.map(({ action, key }, index) =>
              action ? (
                <Typography
                  className="__music_card_menu_item"
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenu(false);
                    toggleMenu(key, data["_id"] ? data["_id"] : "");
                  }}
                >
                  {action}
                </Typography>
              ) : null
            )}
          </Box>
        </OutsideClickHandler>
      ) : null}
    </tr>
  );
}
